'use strict';

/**
 * @ngdoc function
 * @name thothAppApp.controller:ReportingCtrl
 * @description
 * # ReportingCtrl
 * Controller of the thothAppApp
 */
angular.module('thothApp.controllers')
  .controller('ReportingCtrl', ['$scope', 'Project', 'toaster', 'Pagination','$q','Client','Employee', 'Activity', 'FileSaver','ClientsGroup', 'Workspace',
    function ($scope, Project, toaster, Pagination,$q, Client, Employee, Activity, FileSaver, ClientsGroup, Workspace) {

      $scope.userIsAdmin = function() {
        if ('apiUser' in $window.localStorage) {
          const apiUser = JSON.parse($window.localStorage.apiUser);
          if(apiUser.employee) {
            return apiUser.employee.is_admin_group;
          } else {
            return false;
          }
        } else {
          return false;
        }
      }

      $scope.currentFilter = {};
      $scope.employees = []
      $scope.clients = []
      const getDefaultDate = () => {
        var currentDate = moment().subtract(1, "week");
        $scope.downloadStartDate = new Date(currentDate.clone().startOf('isoWeek'))
        $scope.downloadEndDate = new Date(currentDate.clone().endOf('isoWeek'))
        var today = new Date().toISOString().split('T')[0];
        document.getElementById("dateIdStart").setAttribute("max", today);
        document.getElementById("dateIdEnd").setAttribute("max", today);
        $scope.currentFilter.startDate = $scope.downloadStartDate;
        $scope.currentFilter.endDate = $scope.downloadEndDate;
      }
      getDefaultDate();
      $scope.actionFilters = [
        { id: 'project', name: "Proyecto" },
        { id: 'client', name: "Cliente" },
        { id: 'employee', name: "Empleado" },
        { id: 'client_group', name: "Grupo de Cliente" },
        { id: 'workspace', name: "Espacio de Trabajo" }
      ];
      $scope.currentFilter.actionFilter = 'project';

      $scope.updateActionFilter = function() {
        $scope.selectedCustomer = undefined;
        $scope.selectedProject = undefined;
        $scope.selectedEmployee = undefined;
        $scope.selectedClientGroup = undefined;
        $scope.selectedWorkspace = undefined;
        $scope.currentFilter.projectId = null;
        $scope.currentFilter.employeeId = null;
        $scope.currentFilter.clientId = null;
        $scope.currentFilter.clientGroupId = null;
        $scope.currentFilter.workspaceId = null;
        $scope.currentFilter.excludedEmployee = [];
        $scope.currentFilter.excludedClients = [];
        $scope.employees = [];
        $scope.clients = [];
      };

      $scope.projectSearch = function(searchQuery) {
        return Project.searchWithCache(searchQuery);
      };

      $scope.selectedProjectChange = function(project) {
        if (project === undefined) {
          $scope.selectedProject = undefined;
          $scope.currentFilter.projectId = null;
        } else {
          $scope.currentFilter.projectId = project.id;
        }
      };

      $scope.customerSearch = function(searchQuery) {
        if (!searchQuery) {
          return [];
        }
        var customerParams = {
          'params': {
            'search': searchQuery
          }
        };
        var deferred = $q.defer();
        Client.index(customerParams).then(function(response) {
          deferred.resolve(response.data.clients);
        }).catch(function(error) {
          Client.error(error);
          deferred.reject(error);
        });
        return deferred.promise;
      };

      $scope.selectedCustomerChange = function(customer) {
        if (customer === undefined) {
          $scope.selectedCustomer = undefined;
          $scope.currentFilter.clientId = null;
        } else {
          $scope.currentFilter.clientId = customer.id;
        }
      };

      $scope.employeeSearch = function(searchQuery) {
        if (!searchQuery) {
          return [];
        }
        var employeeParams = {
          'params': {
            'search': searchQuery
          }
        };
        var allEmployees = {
          name: "Todos",
          id: "all"
        };
        var deferred = $q.defer();
        Employee.index(employeeParams).then(function(response) {
          let response_data = response.data.employees;
          response_data.unshift(allEmployees)
          deferred.resolve(response_data);
        }).catch(function(error) {
          Employee.error(error);
          deferred.reject(error);
        });
        return deferred.promise;
      };

      $scope.selectedEmployeeChange = function(employee) {
        if (employee === undefined) {
          $scope.selectedEmployee = undefined;
          $scope.currentFilter.employeeId = null;
        } else {
          $scope.currentFilter.employeeId = employee.id;
        }
      };

      $scope.clientGroupSearch = function(searchQuery) {
        if (!searchQuery) {
          return [];
        }
        var clientGroupParams = {
          'params': {
            'search': searchQuery
          }
        };
        var deferred = $q.defer();
        ClientsGroup.index(clientGroupParams).then(function(response) {
          deferred.resolve(response.data.client_groups);
        }).catch(function(error) {
          ClientsGroup.error(error);
          deferred.reject(error);
        });
        return deferred.promise;
      };

      $scope.clientGroupChange = function(clientGroup) {
        if (clientGroup === undefined) {
          $scope.selectedClientGroup = undefined;
          $scope.currentFilter.clientGroupId = null;
          $scope.clients = []
        } else {
          $scope.currentFilter.clientGroupId = clientGroup.id;
          $scope.clients = []

          if (Array.isArray(clientGroup.clients) && clientGroup.clients.length > 0) {
            clientGroup.clients.forEach(e => {
              $scope.clients.push({
                id: e.id,
                name: e.name,
                is_production_ready: e.is_production_ready ? true : false,
                selected: e.is_production_ready ? false : true,
              });
            });
          } else {
            toaster.warning('No hay clientes disponibles en este grupo.');
          }
        }
      };

      $scope.workspaceSearch = function(workspaceQuery) {
        if (!workspaceQuery) {
          return [];
        }
        var workspaceParams = {
          'params': {
            'search': workspaceQuery
          }
        };
        var deferred = $q.defer();
        Workspace.index(workspaceParams).then(function(response) {
          deferred.resolve(response.data.workspaces);
        }).catch(function(error) {
          Workspace.error(error);
          deferred.reject(error);
        });
        return deferred.promise;
      };

      $scope.workspaceChange = function(workspace) {
        if (workspace === undefined) {
          $scope.selectedWorkspace = undefined;
          $scope.currentFilter.workspaceId = null;
          $scope.employees = [];
        } else {
          $scope.currentFilter.workspaceId = workspace.id;
          $scope.employees = [];

          if (Array.isArray(workspace.employees) && workspace.employees.length > 0) {
            workspace.employees.forEach(e => {
              $scope.employees.push({
                id: e.id,
                name: e.name,
                is_active: e.is_active  == "active" ? true : false,
                selected:  e.is_active  == "active" ? false : true
              });
            });
          } else {
            toaster.warning('No hay empleados disponibles en esta área.');
          }
        }
      };

      $scope.downloadButton = function() {
        $scope.currentFilter.excludedEmployee = [];
        $scope.employees.forEach(e => {
          if (e.selected === true) {
            $scope.currentFilter.excludedEmployee.push(e.id);
          }
        });
        $scope.currentFilter.excludedClients = [];
        $scope.clients.forEach(e => {
          if (e.selected === true) {
            $scope.currentFilter.excludedClients.push(e.id);
          }
        });

        if ($scope.currentFilter.actionFilter === 'project' && !$scope.currentFilter.projectId) {
          toaster.warning('Por favor seleccione un proyecto antes de descargar.');
        } else if ($scope.currentFilter.actionFilter === 'client' && !$scope.currentFilter.clientId) {
          toaster.warning('Por favor seleccione un cliente antes de descargar.');
        } else if ($scope.currentFilter.actionFilter === 'employee' && !$scope.currentFilter.employeeId) {
          toaster.warning('Por favor seleccione un empleado antes de descargar.');
        } else if ($scope.currentFilter.actionFilter === 'client_group' && !$scope.currentFilter.clientGroupId) {
          toaster.warning('Por favor seleccione un Grupo de cliente antes de descargar.');
        } else if ($scope.currentFilter.actionFilter === 'workspace' && !$scope.currentFilter.workspaceId) {
          toaster.warning('Por favor seleccione un Grupo de cliente antes de descargar.');
        } else if (!$scope.downloadStartDate || !$scope.downloadEndDate) {
          toaster.warning('Por favor seleccione las fechas de inicio y fin.');
        } else if (new Date($scope.downloadStartDate) > new Date($scope.downloadEndDate)) {
          toaster.warning('La fecha de inicio no puede ser posterior a la fecha de fin.');
        } else {
          var params = {
            current_filter: {
              actionFilter: $scope.currentFilter.actionFilter || '',
              projectId: $scope.currentFilter.projectId || '',
              employeeId: $scope.currentFilter.employeeId || '',
              clientId: $scope.currentFilter.clientId || '',
              clientGroupId: $scope.currentFilter.clientGroupId || '',
              workspaceId: $scope.currentFilter.workspaceId || '',
              startDate: $scope.downloadStartDate || '',
              endDate:  $scope.downloadEndDate || '',
              excludedEmployee: $scope.currentFilter.excludedEmployee || '',
              excludedClients: $scope.currentFilter.excludedClients || ''
            }
          };
          return Activity.ReportActivities( {params: params}).then((response) => {
            var blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
            FileSaver.saveAs(blob, 'SCISA_Reporte_Actividades.csv');
          }).catch(error => {
            toaster.pop('error', 'Actividades', error.data.error);
          }).finally(() => {
          });
        }
      };

  }]);
